export default "__VITE_ASSET__Bpi$xUmt__"